<div class="main medication-panel">
    <div class="title-btn-layout">
        <div class="main-title">
            <h1>Medication Panel</h1>
            <p>Monitor your medication inventory</p>
        </div>
        <div class="new-placement">
            <a routerLink="/add-medication" class="btn btn-action-primary">
                <i class="fas fa-plus"></i> New Medication
            </a>
        </div>
    </div>

    <!-- Advanced Filter -->
    <div class="farm-filter">
        <app-search-filter
            [config]="medicationFilterConfig"
            [userId]="userDetail?.id"
            [externalForm]="filterForm"
            placeholder="Filter medications..."
            (filter)="onMedicationFilterApplied($event)"
            (clear)="onMedicationFilterCleared()"
        ></app-search-filter>
    </div>

    <!-- Info Tiles -->
    <div class="info-tile-container">
        <app-info-tile
            [infoName]="'Total Medications'"
            [infoValue]="totalMedications"
        ></app-info-tile>
        <app-info-tile
            [infoName]="'Total Stock'"
            [infoValue]="totalStock"
        ></app-info-tile>
        <app-info-tile
            [infoName]="'Expiring Soon'"
            [infoValue]="expiringSoon"
        ></app-info-tile>
        <app-info-tile
            [infoName]="'Out of Stock'"
            [infoValue]="outOfStock"
        ></app-info-tile>
    </div>

    <!-- Insights Panel -->
    <app-insights-panel></app-insights-panel>
</div>
